export const IconComment: {
  name: 'icon_comment-03869983e228'
} = {
  name: 'icon_comment-03869983e228'
}
